module.exports = __webpack_public_path__ + "static/arrastre_manguera_dos_ruedas-3b90be0bfbebbf20c896f0aea4171ec6.jpg";